import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import styles from "../../styles/tenant.module.css"
import { useFieldArray, useForm } from 'react-hook-form'
import { gql, useMutation, useQuery } from "@apollo/client";
import { GET_API_CONFIG_BY_ID, GET_TENANT_BY_ID, UPDATE_TENANT_API_CONFIG } from "../../graphql/TenantQueries";
import ErrorDisplay from "../common/ErrorDisplay";


function EditApiConfigModal({ setOpenEditApiConfigModal, setOpenActionModal, fieldData }: any) {
    const { register, handleSubmit, formState: { errors }, control, watch } = useForm({})

    const [updateTenantApiConfig, { loading: mutationLoading, error: mutationError }] = useMutation(UPDATE_TENANT_API_CONFIG, {
        refetchQueries: [
          {query: GET_API_CONFIG_BY_ID, variables: { id: fieldData }  }, 
          'getApiConfigByTenantId' 
        ],
      });
    const { loading: tenantLoading, error: tenantError, data: tenantData } = useQuery(GET_TENANT_BY_ID, { variables: { id: fieldData } })
    const { loading: apiLoading, error: apiError, data: apiData } = useQuery(GET_API_CONFIG_BY_ID, { variables: { id: fieldData } })

    const formSubmit = async (formData: any) => {
        try {
            const input = formData.input;
            const promises = input.map((el: any) => {
                const id = el._id;
                delete el._id; 
                return updateTenantApiConfig({ variables: { id: id, input: { ...el, tenant: { name: `${tenantData.getTenantById.name}`, id: `${tenantData.getTenantById.id}`, displayName: `${tenantData.getTenantById.displayName}` } } } });
            });
            
            await Promise.all(promises);
            setOpenActionModal(false);
            setOpenEditApiConfigModal(false);
        } catch (error) {
            console.error('Error updating API config:', error);
        }
    }



    if (tenantLoading || apiLoading) return <h3>Loading...</h3>
    return (
        <>
            <div className={styles["formModalContainer"]}>
                <div className={styles["title"]}>
                    <h1>Edit Tenant API Configuration</h1>
                </div>
                <div className={styles["body"]}>
                    <form onSubmit={handleSubmit(formSubmit)}>
                        {apiData?.getApiConfigByTenantId.length === 0 && <h3 style={{textAlign: 'center', paddingBottom: '100px'}}>No API Configuration for this Tenant</h3>}
                        {apiData?.getApiConfigByTenantId && apiData.getApiConfigByTenantId.map((el: any, index: number) =>

                            <>
                                <h3 style={{ display: "flex", paddingTop: "20px" }} key={index}>API Configuration</h3>
                                <label className={styles["label"]}>API Configuration Name</label>
                                <input {...register(`input[${index}].name`)} className={styles["input"]} defaultValue={el.name}></input>
                                <label className={styles["label"]}>API Key</label>
                                <input {...register(`input[${index}].key`)} className={styles["input"]} defaultValue={el.key}></input>
                                <label className={styles["label"]}>API URL</label>
                                <input {...register(`input[${index}].url`)} className={styles["input"]} defaultValue={el.url}></input>
                                <div>
                                <label className={styles["label"]}>Collector Type</label>
                                <input {...register(`input[${index}].collectorType`)} className={styles["input"]} defaultValue={el.collectorType}></input>
                                <label className={styles["label"]}>Timezone</label>
                                <input {...register(`input[${index}].timezone`)} className={styles["input"]} defaultValue={el.timezone}></input>
                                <label className={styles["label"]}>Enabled</label>
                                <input {...register(`input[${index}].enabled`)} className={styles["input"]} defaultValue={el.enabled} type='checkbox'></input>
                                <input {...register(`input[${index}]._id`)} className={styles["input"]} defaultValue={el._id} type={'hidden'}></input>
                                </div>
                                <hr />
                            </>

                        )
                        }

                        <div>
                            <button
                                onClick={() => {
                                    setOpenEditApiConfigModal(false);
                                }}
                                className={styles["button"]}
                            >
                                Cancel
                            </button>
                            {apiData.getApiConfigByTenantId.length > 0 && <input type='submit' className={styles["button"]} />}

                        </div>
                    </form>
                </div>
                <ErrorDisplay error={mutationError} />
            </div>
        </>
    )
}

export default EditApiConfigModal;